export default "__VITE_ASSET__tfkq0KOA__"